import { MarketingRepo } from '@core/repositories'
const resource = '/notifications'

export default {
    getList(config){
        return MarketingRepo.get(`${resource}.json`,config)
    },
    markAllRead(){
        return MarketingRepo.post(`${resource}/read_all.json`)
    },
    getPendingProcess(config){
        return MarketingRepo.get(`/account_sidekiq_logs.json`,config)
    }
}
